import React from 'react';
import './styles.scss';

export default function Error({ headerTxt, children }) {
    return (
        <div data-testid="error-page-content" className="error-page-content tds-margin-tb-large">
            <br />
            <h1 className="error-header">{headerTxt}</h1>
            <div className="error-card-override">
                <div className="card-block">
                    {children}
                    <p data-testid="pHelpText">
                        Please&nbsp;
                        <a data-testid="aStartOver" href={process.env.PUBLIC_URL}>
                            start over
                        </a>
                        &nbsp;or call us at&nbsp;
                        <a data-testid="aHelpNbr" href="tel:18008424271">
                            800-842-4271
                        </a>
                        &nbsp;if you need further assistance.
                    </p>
                </div>
            </div>
        </div>
    );
}
